import React, { useMemo, memo } from 'react';
import {
  arrayOf, object, shape, string, number,
} from 'prop-types';
import InstallmentsItem from './InstallmentsItem';
import MoreInstallments from './MoreInstallments';

const Installments = ({ installmentList }) => {
  if (installmentList.length === 0) {
    return null;
  }

  const installmentListPart1 = useMemo(() => installmentList.slice(0, 12),
    [ installmentList ]);
  const installmentListPart2 = useMemo(
    () => (installmentList.length > 11 ? installmentList.slice(12, installmentList.length) : []),
    [ installmentList ]);

  return <div className="installments-list" >
    {
      installmentListPart1.map((installment, index) => <InstallmentsItem
        key={index}
        {...installment}/>,
      )
    }
    <MoreInstallments installmentList={installmentListPart2}/>
  </div>;
};

Installments.propTypes = {
  installmentList: arrayOf(shape({
    remainingBalance: number,
    currencyCode: string,
    dueDate: object,
  })),
};

Installments.defaultProps = {
  installmentList: [],
};

export default memo(Installments);
